import { Route, Switch } from "react-router-dom";
import { useAppContext } from "~/contexts/appContext";
import { hasGlobalReportingAccess } from "~/utils/userRoles";
import { ArenaDetail } from "./ArenaDetail";
import { ArenaList } from "./ArenaList";
import { ReportingMissingPermissionState } from "./components/MissingPermissionState";
import { ReportTemplateEditor } from "./ReportTemplateEditor";
import { ReportTemplateViewer } from "./ReportTemplateViewer";
import { Settings } from "./Settings";

export const Reporting = () => {
  const { user } = useAppContext();
  const blockGlobalRoutes = !hasGlobalReportingAccess(user.roles);

  return (
    <Switch>
      <Route path="/reporting" exact>
        <ArenaList />
      </Route>
      <Route path="/reporting/settings/data-structures">
        {blockGlobalRoutes ? <ReportingMissingPermissionState /> : <Settings />}
      </Route>
      <Route path="/reporting/settings" exact>
        {blockGlobalRoutes ? <ReportingMissingPermissionState /> : <Settings />}
      </Route>
      <Route path="/reporting/system/templates/new" exact>
        {blockGlobalRoutes ? <ReportingMissingPermissionState /> : <ReportTemplateEditor />}
      </Route>
      <Route path="/reporting/system/templates/duplicate" exact>
        {blockGlobalRoutes ? <ReportingMissingPermissionState /> : <ReportTemplateEditor />}
      </Route>
      <Route path="/reporting/system/templates/:templateId/view" exact>
        <ReportTemplateViewer />
      </Route>
      <Route path="/reporting/system/templates/:templateId">
        {blockGlobalRoutes ? <ReportingMissingPermissionState /> : <ReportTemplateEditor />}
      </Route>
      <Route path="/reporting/:arenaId/templates/new" exact>
        <ReportTemplateEditor />
      </Route>
      <Route path="/reporting/:arenaId/templates/duplicate" exact>
        <ReportTemplateEditor />
      </Route>
      <Route path="/reporting/:arenaId/templates/:templateId/view" exact>
        <ReportTemplateViewer />
      </Route>
      <Route path="/reporting/:arenaId/templates/:templateId">
        <ReportTemplateEditor />
      </Route>
      <Route path="/reporting/:arenaId/data-structures">
        <ArenaDetail />
      </Route>
      <Route path="/reporting/:arenaId" exact>
        <ArenaDetail />
      </Route>
    </Switch>
  );
};
